import { combineReducers } from "redux";
import CreateDocumentForm from "./DocumentReducers/CreateDocumentForm";
import ApplicationForm from "./ApplicationFormReducers/ApplicationForm";
import LoginForm from "./AuthReducers/LoginReducer";
import AdminCRUDForm from "./AdminCRUDReducers/AdminCRUDForm";
import AgencyUserForm from "./AgencyUserCRUDReducer";
import VariantsListReducer from "./DocumentReducers/VariantsListReducer";
import HandleDocumentType from "./ApplicationFormReducers/HandleDocumentType.js";
import FormReducer from "./FormReducer";
import HandleDocumentFormat from "./ApplicationFormReducers/HandleDocumentFormat";
import InstructionReducer from "./InstructionReducer";
import InvoiceListReducer from "./InvoiceReducers/InvoiceListReducer";
import InvoiceDetailReducer from "./InvoiceReducers/InvoiceDetailReducer";
import CustomersReducer from "./InvoiceReducers/CustomersReducer";
import InvoiceFormReducer from "./InvoiceReducers/InvoiceFormReducer";
import CouponDetailReducer from "./InvoiceReducers/CouponDetailReducer";
import LocationCodeListReducer from "./LocationCodeListReducer";

const RootReducer = combineReducers({
  CreateDocumentForm,
  ApplicationForm,
  AdminCRUDForm,
  LoginForm,
  AgencyUserForm,
  VariantsListReducer,
  HandleDocumentType,
  FormReducer,
  HandleDocumentFormat,
  InstructionReducer,
  InvoiceListReducer,
  InvoiceDetailReducer,
  CustomersReducer,
  InvoiceFormReducer,
  CouponDetailReducer,
  LocationCodeListReducer,
});

export default RootReducer;
